export default __webpack_public_path__ + "static/media/group-3.76b85969.svg";